import api from "../../api/index";

const reportUrl = `${process.env.VUE_APP_BASE_URI}/report`;
// const reportTimezonesUrl = `${process.env.VUE_APP_BASE_URI_STAGING}/report/timezones`;

// const createreport = `${process.env.VUE_APP_BASE_URI}/reports`;

// const updatereport = `${process.env.VUE_APP_BASE_URI}/report`;
// const deletereport = `${process.env.VUE_APP_BASE_URI}/report`;

const getDefaultState = () => {
  return {
    reports: [],
    msg: "",
    reportMeta: {},
    reportTimezones: [],
    timezoneLoading: false,
  };
};

const state = getDefaultState();

const getters = {
  reports: (state) => state.reports,
  reportMeta: (state) => state.reportMeta,
  successMsg: (state) => state.msg,
  reportTimezones: (state) => state.reportTimezones,
  timezoneLoading: (state) => state.timezoneLoading,
};

const actions = {
  async getReports({ commit }, params) {
    commit("fetchreports_request");
    const res = await api.get(reportUrl, { params });
    if (res.data.success) {
      commit("fetchreports_success", res.data.payload);
    }
    return res;
  },

  async createReport({ commit }, data) {
    commit("createreport_request");
    const res = await api.post(reportUrl, data);
    if (res.data.success) {
      commit("createreport_success", res.data.message);
    }
    return res;
  },
  async updateReport({ commit }, { id, value }) {
    commit("updatereport_request");
    const res = await api.patch(`${reportUrl}/${id}`, value);
    if (res.data.success) {
      commit("updatereport_success", res.data.message);
    }
    return res;
  },
  async deletereport({ commit }, id) {
    commit("deletereport_request");
    const res = await api.delete(`${reportUrl}/${id}`);
    if (res.data.success) {
      commit("deletereport_success", res.data.message);
    }
    return res;
  },

  async getReportTimezones({ commit }) {
    commit("fetchreporttimezones_request");
    const res = await api.get(`${reportUrl}/timezones`);
    if (res.data.success) {
      commit("fetchreporttimezones_success", res.data.payload.timezones);
    }
    return res;
  },

  async updateErrMsg({ commit }, data) {
    await commit("updateerrmsg_success", data);
  },
  async updateMsg({ commit }, data) {
    await commit("updateMsg_success", data);
  },

  async resetSMSState({ commit }) {
    await commit("resetsmsstate_success");
  },
};

const mutations = {
  fetchreports_request: (state) => (state.status = "loading"),
  fetchreports_success: (state, data) => {
    state.status = "success";
    state.reports = data.data;
    state.reportMeta = data.meta;
  },
  createreport_request: (state) => (state.status = "loading"),
  createreport_success: (state, data) => {
    state.status = "success";
    state.msg = data;
  },
  updatereport_request: (state) => (state.status = "loading"),
  updatereport_success: (state, data) => {
    state.status = "success";
    state.msg = data;
  },
  deletereport_request: (state) => (state.status = "loading"),
  deletereport_success: (state, data) => {
    state.status = "success";
    state.msg = data;
  },
  fetchreporttimezones_request: (state) => (state.timezoneLoading = true),
  fetchreporttimezones_success: (state, data) => {
    state.reportTimezones = data;
    state.timezoneLoading = false;
  },

  resetsmsstate_success: (state) => Object.assign(state, getDefaultState()),
  updateerrmsg_success: (state, data) => (state.errMsg = data),
  updateMsg_success: (state, data) => (state.msg = data),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
